module.exports = "<div class=\"row\">\r\n    <!--<div class=\"col-xs-12 col-md-4\">\r\n    <app-menudesktop></app-menudesktop>\r\n    </div>-->\r\n    <div class=\"col-xs-12 col-md-8 \">       \r\n      <section>            \r\n        <h1>Cargando sus datos...</h1>          \r\n        <div class=\"logos-wrap\">              \r\n        </div>\r\n      </section>     \r\n    </div>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/public/main.component.html
// module id = ../../../../../src/app/public/main.component.html
// module chunks = main